
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getEstimates: (state) => state.estimates,
}